
import { instantiate } from './NoortHive-ecosystem-media-apps-frontend-locco-app-app-locco.uninstantiated.mjs';


const exports = (await instantiate({
})).exports;

export const {
mountLoccoAppComponent,
memory,
_initialize
} = exports


